export const BEESWAX_CUSTOM_LIST_KEYS = {
  default: () => ["beeswax", "list"],
  all: () => [...BEESWAX_CUSTOM_LIST_KEYS.default(), "all"],
  withId: ({ id }: any) => [...BEESWAX_CUSTOM_LIST_KEYS.default(), id],
  withType: ({ type }: any) => [...BEESWAX_CUSTOM_LIST_KEYS.default(), type],
};

export const BEESWAX_CUSTOM_LIST_ITEMS_KEYS = {
  default: ({ id }: { id: number }) => ["beeswax", "list-items", id],

  withPaginaton: ({ id, ...rest }: any) => [
    ...BEESWAX_CUSTOM_LIST_ITEMS_KEYS.default({ id }),
    { ...rest },
  ],
};
